"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const configs_1 = __importDefault(require("./configs"));
const Pill = (props) => {
    const className = [
        "rounded-full relative inline-flex items-center justify-center px-3 py-2 select-none text-sm font-medium whitespace-nowrap",
        configs_1.default?.state?.[props.state] || "",
        configs_1.default?.size?.[props.size] || "",
        props.className || "",
    ];
    return ((0, jsx_runtime_1.jsx)("span", { className: className.join(" "), style: props.style, children: props.children }));
};
Pill.defaultProps = {
    className: "",
    size: "md",
    state: "custom",
};
exports.default = Pill;
